import {Controller as Ctrl, Application as App} from 'stimulus';
import PubSub from 'pubsub-js';

// Adding trigger and on to controllers

PubSub.immediateExceptions = RAILS_ENV === 'development';

class Controller extends Ctrl {
  constructor() {
    super(...arguments);
  }

  trigger(identifier, params) {
    const parts = identifier.split('->');
    if (parts.length < 2) throw new Error('Event identifier is in an incorrect format!');
    const controller = parts[0];
    const action = parts[1];

    PubSub.publish(`stimulus.${controller}.${action}`, params);
  }

  on(action, callback) {
    const controller = this.identifier;
    PubSub.subscribe(`stimulus.${controller}.${action}`, (eventName, params) => callback(params));
  }

  disconnect() {
    const controller = this.identifier;
    PubSub.unsubscribe(`stimulus.${controller}`);
    return super.disconnect();
  }
}

class Application extends App {
  constructor() {
    super(...arguments);
  }

  register(identifier, controllerConstructor) {
    if (this.controllers.indexOf(controllerConstructor) === -1)
      return super.register(identifier, controllerConstructor);
    else console.warning(`Controller "${identifier}" already registered!`);
  }
}

export {Controller, Application};
